import Content from "uxp-documentation/src/pages/uxp-api/reference-html/General/html";
import * as React from 'react';
export default {
  Content,
  React
};